export default "__VITE_ASSET__1867a85f__"